<template>
  <div class="user-info">
    <el-dropdown trigger="click" @command="handleCommand">
      <div class="user-profile">
        <div class="user-avatar">
          <el-icon><User /></el-icon>
        </div>
        <div class="user-details">
          <span class="username">{{ userInfo.user_name }}</span>
          <span class="user-role">{{ getUserRole(userInfo.user_type) }}</span>
        </div>
        <el-icon class="dropdown-icon"><ArrowDown /></el-icon>
      </div>
      <template #dropdown>
        <el-dropdown-menu class="user-dropdown">
          <el-dropdown-item command="profile">
            <el-icon><User /></el-icon>
            <span>个人资料</span>
          </el-dropdown-item>
          <el-dropdown-item command="settings">
            <el-icon><Setting /></el-icon>
            <span>系统设置</span>
          </el-dropdown-item>
          <el-dropdown-item divided command="logout">
            <el-icon><SwitchButton /></el-icon>
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script>
import { logout } from "@/api/sso/login";
import { useRouter } from "vue-router";
import {
  User,
  ArrowDown,
  Setting,
  SwitchButton,
} from "@element-plus/icons-vue";

export default {
  name: "UserInfo",
  components: {
    User,
    ArrowDown,
    Setting,
    SwitchButton,
  },
  setup() {
    const router = useRouter();
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

    const getUserRole = (userType) => {
      const roleMap = {
        1: "超级管理员",
        2: "管理员",
        3: "普通用户",
      };
      return roleMap[userType] || "未知角色";
    };

    const handleCommand = async (command) => {
      switch (command) {
        case "profile":
          // 处理个人资料
          console.log("个人资料");
          break;
        case "settings":
          // 处理系统设置
          console.log("系统设置");
          break;
        case "logout":
          await handleLogout();
          break;
      }
    };

    const handleLogout = async () => {
      try {
        await logout();
        // 清除用户信息和token
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        // 跳转到登录页
        router.push("/login");
      } catch (error) {
        console.error("退出登录失败:", error);
      }
    };

    return {
      userInfo,
      getUserRole,
      handleCommand,
      handleLogout,
    };
  },
};
</script>

<style scoped>
.user-info {
  display: flex;
  align-items: center;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.user-profile::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.user-profile:hover::before {
  left: 100%;
}

.user-profile:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.user-avatar {
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.user-avatar .el-icon {
  font-size: 18px;
  color: white;
}

.user-details {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.username {
  color: white;
  font-weight: 600;
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.user-role {
  color: rgba(255, 255, 255, 0.8);
  font-size: 11px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  line-height: 1.2;
}

.dropdown-icon {
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  transition: transform 0.3s ease;
}

.user-profile:hover .dropdown-icon {
  transform: rotate(180deg);
}

/* 下拉菜单样式 */
:deep(.user-dropdown) {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 8px 0;
}

:deep(.user-dropdown .el-dropdown-menu__item) {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  color: #606266;
  transition: all 0.3s ease;
  border-radius: 6px;
  margin: 2px 8px;
}

:deep(.user-dropdown .el-dropdown-menu__item:hover) {
  background: linear-gradient(
    135deg,
    rgba(64, 158, 255, 0.1) 0%,
    rgba(54, 163, 247, 0.1) 100%
  );
  color: #409eff;
  transform: translateX(5px);
}

:deep(.user-dropdown .el-dropdown-menu__item .el-icon) {
  font-size: 14px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .user-profile {
    padding: 6px 12px;
    gap: 8px;
  }

  .user-avatar {
    width: 32px;
    height: 32px;
  }

  .user-avatar .el-icon {
    font-size: 16px;
  }

  .username {
    font-size: 13px;
  }

  .user-role {
    font-size: 10px;
  }

  .user-details {
    display: none;
  }
}
</style> 